import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledInfoModal = styled.div`
  padding: 2rem;
  border-radius: 12px;
  background-color: ${COLORS.lightGray};
  color: ${COLORS.darkerBlue};
`

export {
  StyledInfoModal
}